import ContentPage from '../cms';

export { getServerSideProps } from '../cms';
export default ContentPage;
